/* eslint-disable */
import React from "react";
import "contents/assets/scss/page/community.scss";
import ImageI from "contents/assets/img/Image1.png";
import ImageII from "contents/assets/img/Image2.png";
import ImageIII from "contents/assets/img/Image3.png";
import ImageIV from "contents/assets/img/Image4.png";
import ImageV from "contents/assets/img/Image5.png";
import ImageVI from "contents/assets/img/Image6.png";
import Paging from "../../component/Inc/Paging";
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
import { Link } from 'react-router-dom';
const Photo = () => {
  return (
    <main className="com_container p_photo">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu5_6">이지 포토</h2>
          <button className="com_btn orange s btn_plus">이지포토 등록</button>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <select className="select">
                <option value="이지수능 (본사)">이지수능 (본사)</option>
              </select>
              <section className="com_board_search">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <span className="divider"> ~ </span>
                  <input
                    type="date"
                    className="com_datepicker"
                    placeholder="2022. 01. 01"
                  />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>

            <hr className="com_divider" />

            <>
              <section className="photo_wrapper">
                <div className="photo_box">
                  <div className="com_info">
                    <Link to="../Community/Photo/Detail" className="name">2023년 파이널 캠페인 시상식</Link>
                    <p className="date">2022, 03, 07</p>
                    <div className="count">
                      <BtnLike/>
                    </div>
                  </div>
                  <div className="photos_list">
                    <div className="photo">
                      <img src={ImageI} alt="image-one" />
                    </div>
                    <div className="photo">
                      <img src={ImageII} alt="image-twe" />
                    </div>
                    <div className="photo">
                      <img src={ImageIII} alt="image-three" />
                    </div>
                    <div className="photo">
                      <img src={ImageIV} alt="image-four" />
                    </div>
                    <div className="photo">
                      <img src={ImageV} alt="image-five" />
                    </div>
                    <div className="photo">
                      <img src={ImageVI} alt="image-six" />
                    </div>
                    <div className="photo_info">
                      <p className="txt">김등록210</p>

                      <div className="photo_stats">
                        <div className="comments">
                          <button
                            type="button"
                            className="btn_comments"
                            onClick={() => {}}
                          ></button>
                          <p className="txt">24</p>
                        </div>
                        <div className="seen">
                          <button
                            type="button"
                            className="btn_seen"
                            onClick={() => {}}
                          ></button>
                          <p>325</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="photo_box">
                  <div className="com_info">
                    <Link to="../Community/Photo/Detail" className="name">2023년 파이널 캠페인 시상식</Link>

                    <p className="date">2022, 03, 07</p>
                    <div className="count">
                      <BtnLike/>
                    </div>
                  </div>
                  <div className="photos_list">
                    <div className="photo">
                      <img src={ImageI} alt="image-one" />
                    </div>
                    <div className="photo">
                      <img src={ImageII} alt="image-twe" />
                    </div>
                    <div className="photo">
                      <img src={ImageIII} alt="image-three" />
                    </div>
                    <div className="photo">
                      <img src={ImageIV} alt="image-four" />
                    </div>
                    <div className="photo">
                      <img src={ImageV} alt="image-five" />
                    </div>
                    <div className="photo">
                      <img src={ImageVI} alt="image-six" />
                    </div>
                    <div className="photo_info">
                      <p className="txt">김등록210</p>

                      <div className="photo_stats">
                        <div className="comments">
                          <button
                            type="button"
                            className="btn_comments"
                            onClick={() => {}}
                          ></button>
                          <p className="txt">24</p>
                        </div>
                        <div className="seen">
                          <button
                            type="button"
                            className="btn_seen"
                            onClick={() => {}}
                          ></button>
                          <p>325</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="photo_box">
                  <div className="com_info">
                    <Link to="../Community/Photo/Detail" className="name">2023년 파이널 캠페인 시상식</Link>
                    <p className="date">2022, 03, 07</p>
                    <div className="count">
                      <BtnLike/>
                    </div>
                  </div>
                  <div className="photos_list">
                    <div className="photo">
                      <img src={ImageI} alt="image-one" />
                    </div>
                    <div className="photo">
                      <img src={ImageII} alt="image-twe" />
                    </div>
                    <div className="photo">
                      <img src={ImageIII} alt="image-three" />
                    </div>
                    <div className="photo">
                      <img src={ImageIV} alt="image-four" />
                    </div>
                    <div className="photo">
                      <img src={ImageV} alt="image-five" />
                    </div>
                    <div className="photo">
                      <img src={ImageVI} alt="image-six" />
                    </div>
                    <div className="photo_info">
                      <p className="txt">김등록210</p>

                      <div className="photo_stats">
                        <div className="comments">
                          <button
                            type="button"
                            className="btn_comments"
                            onClick={() => {}}
                          ></button>
                          <p className="txt">24</p>
                        </div>
                        <div className="seen">
                          <button
                            type="button"
                            className="btn_seen"
                            onClick={() => {}}
                          ></button>
                          <p>325</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="photo_box">
                  <div className="com_info">
                   <Link to="../Community/Photo/Detail" className="name">2023년 파이널 캠페인 시상식</Link>
                    <p className="date">2022, 03, 07</p>
                    <div className="count">
                      <BtnLike/>
                    </div>
                  </div>
                  <div className="photos_list">
                    <div className="photo">
                      <img src={ImageI} alt="image-one" />
                    </div>
                    <div className="photo">
                      <img src={ImageII} alt="image-twe" />
                    </div>
                    <div className="photo">
                      <img src={ImageIII} alt="image-three" />
                    </div>
                    <div className="photo">
                      <img src={ImageIV} alt="image-four" />
                    </div>
                    <div className="photo">
                      <img src={ImageV} alt="image-five" />
                    </div>
                    <div className="photo">
                      <img src={ImageVI} alt="image-six" />
                    </div>
                    <div className="photo_info">
                      <p className="txt">김등록210</p>

                      <div className="photo_stats">
                        <div className="comments">
                          <button
                            type="button"
                            className="btn_comments"
                            onClick={() => {}}
                          ></button>
                          <p className="txt">24</p>
                        </div>
                        <div className="seen">
                          <button
                            type="button"
                            className="btn_seen"
                            onClick={() => {}}
                          ></button>
                          <p>325</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="photo_box">
                  <div className="com_info">
                    <Link to="../Community/Photo/Detail" className="name">2023년 파이널 캠페인 시상식</Link>
                    <p className="date">2022, 03, 07</p>
                    <div className="count">
                      <BtnLike/>
                    </div>
                  </div>
                  <div className="photos_list">
                    <div className="photo">
                      <img src={ImageI} alt="image-one" />
                    </div>
                    <div className="photo">
                      <img src={ImageII} alt="image-twe" />
                    </div>
                    <div className="photo">
                      <img src={ImageIII} alt="image-three" />
                    </div>
                    <div className="photo">
                      <img src={ImageIV} alt="image-four" />
                    </div>
                    <div className="photo">
                      <img src={ImageV} alt="image-five" />
                    </div>
                    <div className="photo">
                      <img src={ImageVI} alt="image-six" />
                    </div>
                    <div className="photo_info">
                      <p className="txt">김등록210</p>

                      <div className="photo_stats">
                        <div className="comments">
                          <button
                            type="button"
                            className="btn_comments"
                            onClick={() => {}}
                          ></button>
                          <p className="txt">24</p>
                        </div>
                        <div className="seen">
                          <button
                            type="button"
                            className="btn_seen"
                            onClick={() => {}}
                          ></button>
                          <p>325</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="photo_box">
                  <div className="com_info">
                    <Link to="../Community/Photo/Detail" className="name">2023년 파이널 캠페인 시상식</Link>
                    <p className="date">2022, 03, 07</p>
                    <div className="count">
                      <BtnLike/>
                    </div>
                  </div>
                  <div className="photos_list">
                    <div className="photo">
                      <img src={ImageI} alt="image-one" />
                    </div>
                    <div className="photo">
                      <img src={ImageII} alt="image-twe" />
                    </div>
                    <div className="photo">
                      <img src={ImageIII} alt="image-three" />
                    </div>
                    <div className="photo">
                      <img src={ImageIV} alt="image-four" />
                    </div>
                    <div className="photo">
                      <img src={ImageV} alt="image-five" />
                    </div>
                    <div className="photo">
                      <img src={ImageVI} alt="image-six" />
                    </div>
                    <div className="photo_info">
                      <p className="txt">김등록210</p>

                      <div className="photo_stats">
                        <div className="comments">
                          <button
                            type="button"
                            className="btn_comments"
                            onClick={() => {}}
                          ></button>
                          <p className="txt">24</p>
                        </div>
                        <div className="seen">
                          <button
                            type="button"
                            className="btn_seen"
                            onClick={() => {}}
                          ></button>
                          <p>325</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <Paging />
            </>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Photo;
